import React from 'react'
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import moment from "moment"
import ProductType from "../table/ProductType"
import {Popover} from 'antd'

ItemErrorRows.propTypes = {
    item: PropTypes.object,
    onChangeProductType: PropTypes.func.isRequired
}

function ItemErrorRows(props) {
    const { item, onChangeProductType } = props

    function _convertTime(stringDate) {
        return moment(stringDate).format("HH:mm DD/MM/YYYY")
    }

    function _convertErrorStyle(value) {
        switch (value) {
            case 'overview':
                return 'Toàn bộ'
            case 'detail':
                return 'Chi tiết'
            case 'print':
                return 'Lỗi in'
            case 'sewing':
                return 'Lỗi may'
            case 'press':
                return 'Lỗi ép'
            case 'fabric':
                return 'Lỗi vải'
            case 'cut':
                return 'Lỗi cắt'
            case 'unknown':
                return 'Không xác định'
            case 'billet':
                return 'Lỗi phôi'
            case 'engrave':
                return 'Lỗi khắc'
            case 'improve':
                return 'Lỗi hoàn thiện'
            case 'other':
                return 'Khác'
            default:
                return ''
        }
    }

    const { production_meta } = { ...item.batch }
    const { printer, presser, material_vendor, import_date, cutter } = { ...production_meta }

    return (
        <tr className="ItemErrorRows" key={item._id}>
            <td className='Barcode'>
                <Link
                    to={`/order-item?template=${!!item.item && item.item.barcode_number}_${!!item.item && item.item.item_number}`}
                    target='_blank'>
                    #{!!item.item && item.item.barcode_number}_{!!item.item && item.item.item_number}
                </Link>
            </td>
            <ProductType types={item.product_type} onChangeProductType={onChangeProductType} />
            <td className="Size">{!!item.item && item.item.size}</td>
            <td className="BatchName">
                <Link to={`/batches/${!!item.batch && item.batch._id}`}>
                    {!!item.batch && item.batch.name}
                </Link>
            </td>
            <td className="DateError">{_convertTime(item.error_at)}</td>
            {/* <td className="ErrorStyle">{_convertErrorStyle(item.error_style)}</td> */}
            <td className="ErrorType">{_convertErrorStyle(item.error_type)}</td>
            <td className="ErrorDetail">
                {
                    (!!item.error_detail && item.error_detail.length > 20) ?
                        <Popover
                            content={<span>{item.error_detail}</span>}
                            title="Chi tiết lỗi"
                            trigger="click"
                            overlayClassName='error-detail-popover'
                        >
                            <span className='text-success cursor-pointer'>{`${item.error_detail.substring(0, 21)}...`}</span>
                        </Popover> :
                        (item.error_detail || '')
                }
            </td>
            <th className="Quantity text-center">{!!item.error_details_count ? (item.error_details_count === 0 ? 0 : item.error_details_count) : '-'}</th>
            <td className="PartnerPrint">
                {!!item.batch && !!item.batch.partner ? item.batch.partner.name : '-'}
            </td>
            <td className="PartnerSewing">
                {!!item.batch && !!item.batch.sewing_partner ? item.batch.sewing_partner.name : '-'}
            </td>
            <td>{printer || '-'}</td>
            <td>{cutter || '-'}</td>
            <td>{material_vendor || '-'}</td>
            <td>{!!import_date ? _convertTime(import_date) : '-'}</td>
            <td className="User">{item.error_marked_by}</td>
        </tr>
    )
}

export default ItemErrorRows